import React, { useMemo } from 'react';
import { getLayout } from 'layouts/layoutData';
import { usePathData } from 'dataProvider/pathData';

/**
 * ヘッダとサイドバーを提供
 */

export default function BaseComponent(props) {
    const { children } = props;
    const { spaRoute } = usePathData();

    const Layout = useMemo(() => {
        return getLayout(spaRoute);
    }, [spaRoute]);

    return <Layout>{children}</Layout>;
}
